import { first } from 'rxjs/operators';
import { RoutingHistoryService } from './../services/routingHistory.service';
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../services';

@Component({
    template: `
        <div fxLayoutAlign="center center">
            <mat-card fxFlex [formGroup]="form">
                <mat-card-title>Invite to Team</mat-card-title>
                <mat-card-content>
                    <mat-card formArrayName="invitations">
                        <ng-container *ngFor="let invitation of invitationGroups.controls; index as i; last as isLast " [formGroupName]="i">
                        <mat-card-content fxLayout.xs="column">
                            <mat-form-field fxFlex="45" fxFlex.xs="100" style="padding-top: 14px;">
                                <input matInput placeholder="EmailAddress" formControlName="emailAddress">
                                <mat-error *ngIf="invitation.get('emailAddress').hasError('required')">Email Address is required.</mat-error>
                                <mat-error *ngIf="invitation.get('emailAddress')?.hasError('pattern')">Email address must be valid.</mat-error>
                            </mat-form-field>
                            <div fxLayout="row" fxFlex="50" fxFlexOffset.gt-xs="5" fxFlex.xs="100">
                                <mat-form-field fxFlex="100">
                                    <textarea matInput placeholder="Invitation Message" formControlName="inviteMessage"></textarea>
                                </mat-form-field>
                                <button *ngIf="invitationGroups.controls.length !== 1" 
                                        mat-icon-button
                                        (click)="removeInvitationGroup(i)"
                                        style="padding-top: 25px;"><mat-icon>close</mat-icon></button>
                            </div>
                        </mat-card-content>
                        <mat-card-actions *ngIf="isLast">
                            <button mat-button [disabled]="form.invalid" (click)="addInvitationGroup()">Invite More</button>
                        </mat-card-actions>
                        </ng-container>
                    </mat-card>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-raised-button color="primary" [disabled]="sendDisabled()" (click)="sendInvites()">Send Invitations</button>                
                    <button mat-button (click)="cancel()">Cancel</button>                
                </mat-card-actions>
            </mat-card>
        </div>
    `
})
export class InviteToTeamComponent {
    form: FormGroup;

    constructor(private router: Router, 
                private fb: FormBuilder,
                private snackBar: MatSnackBar,
                private routingHistoryService: RoutingHistoryService, 
                private userService: UserService) {
        this.form = fb.group({ invitations: fb.array([this.createInvitationGroup()]) });
    }

    addInvitationGroup = () => (<FormArray>this.form.get('invitations')).push(this.createInvitationGroup());

    removeInvitationGroup = (i) => this.invitationGroups.removeAt(i);

    createInvitationGroup = () =>  this.fb.group({
        emailAddress: this.fb.control('', [Validators.required, Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$')]), // TODO validation
        inviteMessage: this.fb.control(''),
        isClient: this.fb.control(true),
        status: this.fb.control('INVITED')
    })

    get invitationGroups (): FormArray {
        return <FormArray>this.form.get('invitations');
    }

    sendDisabled = (): boolean => {
        const atLeastOneValid = (<FormArray>this.form.controls.invitations).controls.reduce((accum, group: FormGroup) => (group.valid || group.controls.emailAddress.value.trim().length === 0) && accum, true);
        const allBlank =  (<FormArray>this.form.controls.invitations).controls.reduce((accum, group: FormGroup) => (group.controls.emailAddress.value.trim().length === 0) && accum, true);
        return !atLeastOneValid || allBlank;
    }

    cancel = () => this.router.navigateByUrl(this.routingHistoryService.getPreviousUrl());

    sendInvites() {
        const invitations = this.form.get('invitations').value
        .filter((el, index) => (<FormArray>this.form.get('invitations')).controls[index].valid);
        this.userService.addNewUsers(invitations).pipe(first())
        .subscribe(() => {
            this.snackBar.open('Invitations sent!.', 'OK', { duration: 3000});
            this.cancel();
        },
        err => {
            if (err.status === 409){
                this.snackBar.open('One of the email addresses you were sending to already exists.', 'OK', { duration: 10000, panelClass: ['errorSnackbar']});
            } else {
                this.snackBar.open('Oops, we were unable to send at least one of the invitations, please contact your site administrator.', 'OK', { duration: 10000, panelClass: ['errorSnackbar']});
            } 
        })
    }
}